export default "__VITE_ASSET__70bccd7f__"